/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ClientDetailsResource } from './';
import {
    ClientDetailsResourceFromJSON,
    ClientDetailsResourceFromJSONTyped,
    ClientDetailsResourceToJSON,
} from './';
import type { ProjectDetailsResource } from './';
import {
    ProjectDetailsResourceFromJSON,
    ProjectDetailsResourceFromJSONTyped,
    ProjectDetailsResourceToJSON,
} from './';
import type { UnknownClientDetailsResource } from './';
import {
    UnknownClientDetailsResourceFromJSON,
    UnknownClientDetailsResourceFromJSONTyped,
    UnknownClientDetailsResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface RepatriationOpportunityGroupSummaryResource
 */
export interface RepatriationOpportunityGroupSummaryResource {
    /**
     * 
     * @type {string}
     * @memberof RepatriationOpportunityGroupSummaryResource
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof RepatriationOpportunityGroupSummaryResource
     */
    companyId: string;
    /**
     * 
     * @type {string}
     * @memberof RepatriationOpportunityGroupSummaryResource
     */
    clientCompanyName?: string;
    /**
     * 
     * @type {ClientDetailsResource}
     * @memberof RepatriationOpportunityGroupSummaryResource
     */
    clientDetails?: ClientDetailsResource;
    /**
     * 
     * @type {UnknownClientDetailsResource}
     * @memberof RepatriationOpportunityGroupSummaryResource
     */
    unknownClientDetails?: UnknownClientDetailsResource;
    /**
     * 
     * @type {ProjectDetailsResource}
     * @memberof RepatriationOpportunityGroupSummaryResource
     */
    projectDetails: ProjectDetailsResource;
    /**
     * 
     * @type {string}
     * @memberof RepatriationOpportunityGroupSummaryResource
     */
    managerNote?: string;
}

/**
 * Check if a given object implements the RepatriationOpportunityGroupSummaryResource interface.
 */
export function instanceOfRepatriationOpportunityGroupSummaryResource(value: object): value is RepatriationOpportunityGroupSummaryResource {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('projectDetails' in value) || value['projectDetails'] === undefined) return false;
    return true;
}

export function RepatriationOpportunityGroupSummaryResourceFromJSON(json: any): RepatriationOpportunityGroupSummaryResource {
    return RepatriationOpportunityGroupSummaryResourceFromJSONTyped(json, false);
}

export function RepatriationOpportunityGroupSummaryResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): RepatriationOpportunityGroupSummaryResource {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'companyId': json['companyId'],
        'clientCompanyName': json['clientCompanyName'] == null ? undefined : json['clientCompanyName'],
        'clientDetails': json['clientDetails'] == null ? undefined : ClientDetailsResourceFromJSON(json['clientDetails']),
        'unknownClientDetails': json['unknownClientDetails'] == null ? undefined : UnknownClientDetailsResourceFromJSON(json['unknownClientDetails']),
        'projectDetails': ProjectDetailsResourceFromJSON(json['projectDetails']),
        'managerNote': json['managerNote'] == null ? undefined : json['managerNote'],
    };
}

export function RepatriationOpportunityGroupSummaryResourceToJSON(value?: RepatriationOpportunityGroupSummaryResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'companyId': value['companyId'],
        'clientCompanyName': value['clientCompanyName'],
        'clientDetails': ClientDetailsResourceToJSON(value['clientDetails']),
        'unknownClientDetails': UnknownClientDetailsResourceToJSON(value['unknownClientDetails']),
        'projectDetails': ProjectDetailsResourceToJSON(value['projectDetails']),
        'managerNote': value['managerNote'],
    };
}

